import { render, staticRenderFns } from "./userTop.vue?vue&type=template&id=5f60b758&scoped=true&"
import script from "./userTop.vue?vue&type=script&lang=js&"
export * from "./userTop.vue?vue&type=script&lang=js&"
import style0 from "./userTop.vue?vue&type=style&index=0&id=5f60b758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f60b758",
  null
  
)

export default component.exports